import api from '@/helpers/api'
import Page from "../pages/model";
import EducationPlan from '../education-plan/model'
import { assign, each, get, map } from 'lodash'
import { STATUS_APPROVED, STATUS_DECLINED } from './model'



export default {
    state: {

    },

    mutations: {

    },

    getters: {

    },

    actions: {
        create (store, item) {
            Page.dispatch('addLoader', 'share.create')
            let post = {organizationId: item.organizationId, educationPlanId: item.educationPlanId}

            return api.post('/api/v1/educationplan/Share', post)
                .then(res => {
                    store.dispatch('insertOrUpdate', { data: get(res.data, 'data.shares', []) })
                    return res.data
                }).finally(()=>{
                    Page.dispatch('removeLoader', 'share.create')
                })
        },
        remove (store, id) {
            Page.dispatch('addLoader', 'share.remove')

            return api.delete('/api/v1/share/Delete', {params: {id}})
            .then(res => {
                store.dispatch('delete', res.data.data.id)
                return res.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'share.remove')
            })
        },
        update (store,  item) {
            Page.dispatch('addLoader', 'share.update')
            let post = item

            return api.post('/api/v1/educationplan/Share', post)
            .then(res => {
                store.dispatch('insertOrUpdate', { data: res.data.data })

                return res.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'share.update')
            })
        },
        save (store, data) {
            Page.dispatch('addLoader', 'share.save')
            return store.dispatch(data.id ? 'update' : 'create', data).finally(()=>{
                Page.dispatch('removeLoader', 'share.save')
            })
        },
        approve(store,  share) {
            Page.dispatch('addLoader', 'share.approve')
            let post = assign({}, share, {status: STATUS_APPROVED})

            return store.dispatch('update', post)
                .then(res => {
                    return res
                }).finally(()=>{
                    Page.dispatch('removeLoader', 'share.approve')
                })
        },
        decline(store,  share) {
            Page.dispatch('addLoader', 'share.decline')
            let post = assign({}, {status: STATUS_DECLINED}, share)
            return store.dispatch('update', post)
            .then(res => {
                return res
            }).finally(()=>{
                Page.dispatch('removeLoader', 'share.decline')
            })
        },
        fetchById(store, itemId) {
            Page.dispatch('addLoader', 'share.fetchById')

            return api.get(`/api/v1/share/${itemId}`)
                .then(res => {
                    store.dispatch('insertOrUpdate', { data: res.data.data })
                    return res.data
                }).finally(()=>{
                    Page.dispatch('removeLoader', 'share.fetchById')
                })
        },
        fetchItems (store, params) {
            Page.dispatch('addLoader', 'share.fetchItems')

            return api.get('/api/v1/educationplan', {params: assign({}, params)})
                .then(res => {
                    EducationPlan.dispatch('insertOrUpdate', { data: res.data.data })

                    let data = []
                    each(res.data.data, item => {
                        each(item.shares, share => {
                            data.push(share)
                        })
                    })
                    return {data: data, meta: res.data.meta}
                }).finally(()=>{
                    Page.dispatch('removeLoader', 'share.fetchItems')
                })
        },
    }
}
